<template>
  <div>
    <v-layout>
      <v-flex v-if="tab === 'list'">
        <v-layout v-if="itemDetail && itemDetail.customer">
          <v-flex xs12 md6>
            <v-btn color="primary" dark text @click="add()">新增</v-btn>
          </v-flex>
        </v-layout>
        <table-view :columnKeys="columnKeys"
                    :items="items"
                    :loading="loading"
                    :total-items="totalItems"
                    @cellEvent="cellEvent"
                    @handleLoadData="reset">
        </table-view>
      </v-flex>

      <v-flex v-if="tab === 'add' || tab === 'edit' || tab === 'searchAdd'">
        <v-layout v-if="tab === 'searchAdd' || tab === 'edit'">
          <v-flex md6 xs6>
            <v-checkbox label="查詢汽車" v-model="isSearchCar"></v-checkbox>
          </v-flex>
          <v-flex md6 xs6>
            <v-btn color="primary" dark text :loading="loading" @click="searchEvent()">查詢</v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="tab === 'searchAdd'">
          <v-flex md6 xs6>
            <v-text-field v-model="displayId" label="案件編號" @keyup.enter="searchEvent()" outline></v-text-field>
          </v-flex>
          <v-flex md6 xs6>
            <v-btn color="primary" dark text :loading="loading" @click="searchEvent()">查詢</v-btn>
          </v-flex>
        </v-layout>

        <template v-if="tab === 'add' || tab === 'edit'">
          <v-progress-circular indeterminate v-if="loading"/>
          <v-layout>
            <v-flex xs12 md6>
              <v-btn color="primary" dark text @click="back">返回</v-btn>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;" v-if="itemDetail">
            <span class="subheading">案件編號: {{ itemDetail.displayId }} | 姓名：{{ itemDetail.customer ? itemDetail.customer.name : itemDetail.name }}</span>
          </v-layout>
        </template>

        <template v-if="!loading && editedItem">
          <v-layout justify="center" style="margin-bottom: 10px;" v-if="tab === 'searchAdd'">
            <span class="subheading">案件編號: {{ editedItem.displayId }} | 姓名：{{ editedItem.customer ? editedItem.customer.name : editedItem.name }}</span>
          </v-layout>
          <v-layout type="flex" justify="center" style="margin-bottom: 10px;">
            <v-flex xs12 md6>
              <v-text-field type="number" v-model="insureInfo.beforePrice" label="內扣款" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout type="flex" justify="center" style="margin-bottom: 10px;">
            <v-flex xs12 md6>
              <v-select v-model="insureInfo.originVendor" label="代償前代金額"
                        :items="['嘉好代償','通路代償','公司代償']"></v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field type="number" v-model="insureInfo.originAmount" label="代償金額" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout type="flex" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-autocomplete
                :items="insuredMemberList"
                item-text="displayName"
                item-value="agentId"
                v-model="insureInfo.insureAgentId"
                label="對保人員"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-autocomplete
                :items="processMemberList"
                item-text="displayName"
                item-value="agentId"
                v-model="insureInfo.realInsureAgentId"
                label="派對人員"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout type="flex" justify="center" style="margin-bottom: 10px;">
            <v-flex xs12 md6>
              <v-autocomplete
                :items="typeList"
                v-model="insureInfo.type"
                label="對象"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="insureInfo.otherName" label="其他費用名稱" outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.otherPrice" label="其他費用金額" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.insureAmount" label="本票金額" outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.guaranteeCash" label="對保收現" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.insureAmount2" label="本票金額(第二張)"
                            outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.insureAmount3" label="本票金額(第三張)"
                            outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.exposuresCash" label="風險承擔費" outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.engravedSeal" label="代刻印章" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.postage" label="郵資" outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field type="number" v-model="insureInfo.emptyFare" label="空趟費" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;" v-if="this.isAdmin || this.isStaff">
            <v-flex>
              <v-text-field v-model="insureInfo.actualGuaranteeCash" label="實際對保費" outline></v-text-field>
            </v-flex>
            <v-flex>
              <date-picker class="ml-2" :date.sync="insureInfo.insureDate" :date-string="'對保日期'"/>
            </v-flex>
            <!--          <v-flex>-->
            <!--            <v-text-field v-model="insureInfo.foreignGuarantee" label="對外對保費" outline></v-text-field>-->
            <!--          </v-flex>-->
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="insureInfo.carId" label="車牌" outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="insureInfo.creditPrice" label="申辦金額" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="insureInfo.approvedNotePrice" label="收代扣同意切結書費用(附檔)"
                            outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="insureInfo.agentNotePrice" label="代簽委任代辦契約書費用" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="insureInfo.settingPrice" label="機車動保設定費" outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="insureInfo.motoNPrice" label="機車N對保費" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="insureInfo.realPrice" label="實際撥款金額" outline></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="insureInfo.otherPrice2" label="其他衍伸費用" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-btn class="primary" @click="calculateRealAmount">計算實際撥款金額</v-btn>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-checkbox v-model="insureInfo.check1" label="不收印章(也不收代刻費)，僅需簽代刻同意書即可"></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox v-model="insureInfo.check2"
                          label="證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-checkbox v-model="insureInfo.check3" label="收牌登(可影本或拍照，照片需清楚、完整)"></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox v-model="insureInfo.check4" label="設定中，免收牌登"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-checkbox v-model="insureInfo.check5" label="收結清委託書(附檔)"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-textarea
                outlined
                name="input-7-4"
                label="備註"
                v-model="insureInfo.memo">
              </v-textarea>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;" v-if="editedItem">
            <v-flex>
              <v-layout>
                <span class="subheading"><span class="red--text">(*)</span>附加檔案</span>
              </v-layout>
              <upload-view :item-detail="editedItem" :is-official="false" :show-upload-button="false"
                           @confirmImages="confirmImages"></upload-view>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;" v-if="insureInfo.fireUrl">
            <v-flex>
              <v-layout>
                <img class="image-view" style="max-width: 300px;" :src="insureInfo.fireUrl" @click="openURL(insureInfo.fireUrl)"/>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout justify="center">
            <v-flex>
              <v-btn class="primary" :loading="saveLoading" @click="save">儲存
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn class="red" dark text @click="cancelEvent">取消
              </v-btn>
            </v-flex>
          </v-layout>
        </template>

      </v-flex>
    </v-layout>


  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UploadView from '../components/UploadView';
import CaseInsureModel from '../models/CaseInsureModel';
import common from '../mixins/common';
import TableView from '@/components/TableView.vue';
import DatePicker from '@/components/DatePicker.vue';
import { getCurrentDate } from '@/pages/utils/tool';
import { getCarFinanceInfo } from '@/store/actions';

export default {
  props: ['itemDetail', 'show', 'mode'],
  name: 'CaseInsureView',
  components: {
    DatePicker,
    TableView,
    UploadView
  },
  mixins: [common],
  data() {
    return {
      displayId: '',
      saveLoading: false,
      loadingText: '載入中...',
      signDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      editedItem: null,
      insureInfo: {
        insureId: '',
        caseId: '',
        displayId: '',
        insureAgentId: '',
        insureAgent: '',
        realInsureAgentId: '',
        realInsureAgent: '',
        type: '',
        otherName: '',
        otherPrice: 0,
        insureAmount: 0,
        guaranteeCash: 0,   // 對保收現
        exposuresCash: 0,
        engravedSeal: 0, // 代刻印章
        actualGuaranteeCash: 1500, // 實際對保費
        foreignGuarantee: 0,
        postage: 0, // 郵資
        emptyFare: 0, // 空趟費
        memo: '',
        status: 0,
        insureDate: '',
        carId: '', // 車牌
        creditPrice: 0,
        approvedNotePrice: 0, // 收代扣同意切結書OOOO元(附檔)
        insureAmount2: 0, // 本票2
        insureAmount3: 0,
        agentNotePrice: 0, // 代簽委任代辦契約書OOOO元
        settingPrice: 0, // 機車動保設定費OOOO元
        motoNPrice: 0,
        otherPrice2: 0, // 其他衍伸費用
        check1: false,
        check2: false,
        check3: false,
        check4: false,
        check5: false,
        beforePrice: 0,
        originVendor: '',
        originAmount: 0,
        fireUrl: null,
      },
      uploadFiles: [],
      insureAgentId: '',
      insureAgent: '',
      realInsureAgentId: '',
      realInsureAgent: '',
      typeList: ['對保人員', '通路'],
      insuredMemberList: [],
      processMemberList: [],
      items: [],
      loading: false,
      totalItems: 0,
      selectInsureId: '',
      tab: 'list',
      searchData: null,
      isSearchCar: false,
    };
  },
  watch: {
    mode(value) {
      this.tab = value;
    },
    show(value) {
      console.log(`show = ${value} | ${this.tab}`);
      if (value === true) {
        this.uploadFiles = [];
        // this.getItem();
        if (this.tab !== 'searchAdd') {
          this.loadData();
        }
      } else {
        this.resetData();
      }
    },
    'insureInfo.insureAgentId': {
      handler: function (value, oldVal){
        const find = this.getAgentList.find(
          (agent) => agent.agentId === value
        );
        if (find) {
          this.insureInfo.insureAgent = find.displayName;
          if (this.insureInfo.actualGuaranteeCash === 0){
            this.insureInfo.actualGuaranteeCash = find.insurePrice ? find.insurePrice : 0;

            if (this.itemDetail.platform === 0) { // 裕富
              if (find.richInsurePrice > 0) {
                this.insureInfo.actualGuaranteeCash = find.richInsurePrice;
              }
            } else if (this.itemDetail.platform === 1) { // 和潤
              if (find.loanhftcInsurePrice > 0) {
                this.insureInfo.actualGuaranteeCash = find.loanhftcInsurePrice;
              }
            } else if (this.itemDetail.platform === 2) { // 中租
              if (find.finatradeInsurePrice > 0) {
                this.insureInfo.actualGuaranteeCash = find.finatradeInsurePrice;
              }
            }
          }

          this.$forceUpdate();
        }
      },
      deep: true,
    },
    'insureInfo.realInsureAgentId': {
      handler: function (value, oldVal){
        const find = this.getAgentList.find(
          (agent) => agent.agentId === value
        );
        if (find) {
          this.insureInfo.realInsureAgent = find.displayName;
        }
      },
      deep: true,
    },
    'insureInfo.type': {
      handler: function (value, oldVal){
        console.log(`watch insureInfo.type ${value}`);
        if (value === '通路') {
          const find = this.getAgentList.find(
            (agent) => agent.agentId === this.itemDetail.agentId
          );
          console.log(`itemDetail = ${JSON.stringify(this.itemDetail)}`);
          console.log(`agents = ${this.getAgentList.length} | 通路資料 =  ${JSON.stringify(find)}`);
          if (find) {
            if (this.itemDetail.platform === 0) { // 裕富
              if (find.richInsurePrice > 0) {
                this.insureInfo.actualGuaranteeCash = find.richInsurePrice;
              }
            } else if (this.itemDetail.platform === 1) { // 和潤
              if (find.loanhftcInsurePrice > 0) {
                this.insureInfo.actualGuaranteeCash = find.loanhftcInsurePrice;
              }
            } else if (this.itemDetail.platform === 2) { // 中租
              if (find.finatradeInsurePrice > 0) {
                this.insureInfo.actualGuaranteeCash = find.finatradeInsurePrice;
              }
            }
            this.$forceUpdate();
          }
        } else {
          const find = this.getAgentList.find(
            (agent) => agent.agentId === this.insureInfo.insureAgentId
          );
          console.log(`itemDetail = ${JSON.stringify(this.itemDetail)}`);
          console.log(`agents = ${this.getAgentList.length} | 對保人資料 =  ${JSON.stringify(find)}`);
          if (find) {
            this.insureInfo.actualGuaranteeCash = find.insurePrice;
            this.$forceUpdate();
          }
        }
      },
      deep: true,
    },
  },
  created() {
    // this.getItem();
  },
  mounted() {
    this.$forceUpdate();
  },
  computed: {
    ...mapGetters(['getAgentList']),
    columnKeys() {
      return [
        { value: 'edit', text: '編輯', sortable: false, required: false, color: 'primary', isEvent: true },
        { value: 'caseId', text: '系統編號', sortable: true, required: false },
        { value: 'displayId', text: '案件編號', sortable: true, required: false },
        { value: 'name', text: '申請人', sortable: true, required: false },
        { value: 'insureAgent', text: '對保人員', sortable: true, required: false },
        { value: 'realInsureAgent', text: '派對人員', sortable: true, required: false },
        { value: 'type', text: '對象', sortable: true, required: false },
        { value: 'actualGuaranteeCash', text: '實際對保費', sortable: true, required: false },
        { value: 'delete', text: '刪除', sortable: false, required: false, isEvent: true }];
    },
  },
  methods: {
    ...mapActions(['saveFinanceCreditData', 'fetchCreditProductInfo', 'uploadImageData', 'saveInsureInfo', 'fetchAgentList'
      , 'createInsureInfo', 'deleteInsureInfo', 'getInsureInfo', 'getInsureInfoList', 'getFinanceSimpleInfo', 'getCarFinanceInfo']),
    openURL(url){
      window.open(url, '_blank')
    },
    calculateRealAmount(){
      // 申辦總額-其他衍生費用-機車動保設定費-機車N對保費-內扣款項-代償前貸金額=實際撥款金額
      let realAmount = 0;
      const creditPrice = this.insureInfo.creditPrice || this.insureInfo.creditPrice === '' ? this.insureInfo.creditPrice : 0;
      const otherPrice2 = this.insureInfo.otherPrice2 || this.insureInfo.otherPrice2 === '' ? this.insureInfo.otherPrice2 : 0;
      const settingPrice = this.insureInfo.settingPrice || this.insureInfo.settingPrice === '' ? this.insureInfo.settingPrice : 0;
      const motoNPrice = this.insureInfo.motoNPrice || this.insureInfo.motoNPrice === '' ? this.insureInfo.motoNPrice : 0;
      const beforePrice = this.insureInfo.beforePrice || this.insureInfo.beforePrice === '' ? this.insureInfo.beforePrice : 0;
      const originAmount = this.insureInfo.originAmount || this.insureInfo.originAmount === '' ? this.insureInfo.originAmount : 0;
      console.log(`creditPrice ${creditPrice} otherPrice2 ${otherPrice2} settingPrice ${settingPrice} motoNPrice ${motoNPrice} beforePrice ${beforePrice} ${originAmount}`)
      realAmount = creditPrice - otherPrice2 - settingPrice - motoNPrice - beforePrice - originAmount;
      this.insureInfo.realPrice = realAmount;
      this.$forceUpdate();
    },
    setBeforePrice() {
      this.insureInfo.beforePrice = this.getBeforePrice(this.itemDetail);
    },
    add() {
      this.tab = 'add';
      this.getItem();
    },
    back() {
      this.tab = 'list';
    },
    async save() {
      this.loadingText = '儲存中...';
      this.saveLoading = true;

      if(!this.editedItem.imageList){
        this.editedItem.imageList = [];
      }

      for (let file of this.uploadFiles) {
        const uploadResult = await this.uploadImageData({
          name: file.name,
          image: file.image,
        });
        console.log(`uploadResult == ${JSON.stringify(uploadResult)}`);
        this.editedItem.imageList.push(uploadResult);
        this.insureInfo.fireUrl = uploadResult;
      }

      console.log(`saveFinanceCreditData ${JSON.stringify(this.editedItem)}`);
      const result = await this.saveFinanceCreditData(this.editedItem);
      console.log(`saveFinanceCreditData ${JSON.stringify(result)}`);
      if (this.tab === 'add' || this.tab === 'searchAdd') {
        const sqlResult = await this.createInsureInfo(this.insureInfo);
        console.log(`createInsureInfo ${JSON.stringify(sqlResult)}`);
      } else if (this.tab === 'edit') {
        const sqlResult = await this.saveInsureInfo(this.insureInfo);
        console.log(`saveInsureInfo ${JSON.stringify(sqlResult)}`);
      }
      this.saveLoading = false;
      this.resetData();
      // this.$emit('saveEvent', this.editedItem);
    },
    getItem() {
      console.log(`getItem`)
      this.loading = true;
      this.fetchAgentList()
        .then(() => {
          this.insuredMemberList = this.getAgentList.filter(agent => agent.authority === 'staff'
            || agent.authority === 'insureAgent');
          this.processMemberList = this.getAgentList.filter(agent => agent.authority === 'staff');
        });
      if (this.searchData) {
        this.insureInfo.caseId = this.searchData.caseId;
        this.insureInfo.displayId = this.searchData.displayId;
      } else {
        this.insureInfo.caseId = this.itemDetail.caseId;
        this.insureInfo.displayId = this.itemDetail.displayId;
        this.editedItem = this.itemDetail;
      }
      if (this.tab === 'add' || this.tab === 'searchAdd'){
        this.insureInfo.insureDate = getCurrentDate();
      }


      console.log(`caseId ${this.insureInfo.caseId}`);
      console.log(`editedItem ${JSON.stringify(this.editedItem)}`);
      if (this.isSearchCar){
        this.loading = false;
        this.editedItem = this.itemDetail;
        this.$forceUpdate();
      } else {
        this.fetchCreditProductInfo({ caseId: this.insureInfo.caseId })
          .then(async (results) => {
            if (results.length !== 0) {
              this.editedItem = results[0];
              if (!this.editedItem.imageList) {
                this.editedItem.imageList = [];
              }
              if (!this.editedItem.caseInsure) {
                this.editedItem.caseInsure = new CaseInsureModel();
              }

              this.insureInfo.creditPrice = this.editedItem.vendor.totalPrice;
            }
            this.loading = false;
            this.setBeforePrice();
            this.$forceUpdate();
          });
      }
      this.$forceUpdate();
    },
    cancelEvent() {
      this.$emit('cancelEvent', null);
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    confirmImages(files) {
      console.log(`files == ${JSON.stringify(files)}`);
      this.uploadFiles = files;
    },
    async loadData() {
      console.log(`load list = ${this.itemDetail.caseId}`);
      try {
        this.loading = true;
        const res = await this.getInsureInfoList({ caseId: this.itemDetail.caseId });
        const result = res.data;
        if (result && result.statusCode === 0) {
          this.items = result.data;
          this.totalItems = this.items.length;
        }
        this.$forceUpdate();
      } catch (e) {
        console.log(`loadData error`, e);
      } finally {
        this.loading = false;
      }
    },
    async cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`);
      if (props.key === 'edit') {
        this.tab = 'edit';
        this.insureInfo = props.item;

        if (!this.insureInfo.carId) {
          this.insureInfo.carId = '';
        }
        if (!this.insureInfo.creditPrice) {
          this.insureInfo.creditPrice = 0;
        }
        if (!this.insureInfo.approvedNotePrice) {
          this.insureInfo.approvedNotePrice = 0;
        }
        if (!this.insureInfo.insureAmount2) {
          this.insureInfo.insureAmount2 = 0;
        }
        if (!this.insureInfo.insureAmount3) {
          this.insureInfo.insureAmount3 = 0;
        }
        if (!this.insureInfo.agentNotePrice) {
          this.insureInfo.agentNotePrice = 0;
        }
        if (!this.insureInfo.settingPrice) {
          this.insureInfo.settingPrice = 0;
        }
        if (!this.insureInfo.motoNPrice) {
          this.insureInfo.motoNPrice = 0;
        }
        if (!this.insureInfo.otherPrice2) {
          this.insureInfo.otherPrice2 = 0;
        }
        if (!this.insureInfo.check1) {
          this.insureInfo.check1 = false;
        }
        if (!this.insureInfo.check2) {
          this.insureInfo.check2 = false;
        }
        if (!this.insureInfo.check3) {
          this.insureInfo.check3 = false;
        }
        if (!this.insureInfo.check4) {
          this.insureInfo.check4 = false;
        }
        if (!this.insureInfo.check5) {
          this.insureInfo.check5 = false;
        }

        if (!this.insureInfo.beforePrice) {
          this.insureInfo.beforePrice = 0;
        }
        if (!this.insureInfo.originVendor) {
          this.insureInfo.originVendor = '';
        }
        if (!this.insureInfo.originAmount) {
          this.insureInfo.originAmount = 0;
        }
        // this.getItem();
        this.displayId = this.insureInfo.displayId;
        await this.searchEvent();
      }
      if (props.key === 'delete') {
        await this.deleteInsureInfo({
          insureId: props.item.insureId,
        });
        await this.loadData();
      }
    },
    reset() {
      this.loadData();
    },
    resetData() {
      this.displayId = '';
      this.editedItem = null;
      this.insureInfo = {
        insureId: '',
        caseId: '',
        displayId: '',
        insureAgentId: '',
        insureAgent: '',
        realInsureAgentId: '',
        realInsureAgent: '',
        type: '',
        otherName: '',
        otherPrice: 0,
        insureAmount: 0,
        guaranteeCash: 0,   // 對保收現
        exposuresCash: 0,
        engravedSeal: 0, // 代刻印章
        actualGuaranteeCash: 1500, // 實際對保費
        foreignGuarantee: 0,
        postage: 0, // 郵資
        emptyFare: 0, // 空趟費
        memo: '',
        status: 0,
        insureDate: '',
        carId: '', // 車牌
        creditPrice: 0,
        approvedNotePrice: 0, // 收代扣同意切結書OOOO元(附檔)
        insureAmount2: 0, // 本票2
        insureAmount3: 0,
        agentNotePrice: 0, // 代簽委任代辦契約書OOOO元
        settingPrice: 0, // 機車動保設定費OOOO元
        motoNPrice: 0,
        otherPrice2: 0, // 其他衍伸費用
        check1: false,
        check2: false,
        check3: false,
        check4: false,
        check5: false,
        beforePrice: 0,
        originVendor: '',
        originAmount: 0
      };
      if (this.tab === 'searchAdd') {
        this.$emit('saveEvent');
      } else {
        this.tab = 'list';
      }

    },
    async searchEvent() {
      // if (this.editedItem && this.editedItem.displayId !==''){
      //   this.displayId = this.editedItem.displayId;
      // }
      if (!this.displayId || this.displayId === '') {
        this.showMessageDialog('請輸入案件編號');
        return;
      }
      this.loading = true;
      let res;
      if (this.isSearchCar){
        res = await this.getCarFinanceInfo({ caseId: this.displayId });
      } else {
        res = await this.getFinanceSimpleInfo({ searchValue: this.displayId });
      }
      this.loading = false;
      const result = res.data;
      if (result && result.statusCode === 0) {
        if (result.data) {
          this.searchData = result.data;
          this.itemDetail = this.searchData;
          this.getItem();
        } else {
          this.showMessageDialog('找不到案件資料');
        }
      } else {
        this.showMessageDialog(result.message ? result.message : '找不到資料');
      }
    },
  }
};

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/CaseInsureView.vue